module.exports = __webpack_public_path__ + "static/img/apply_banner_02.943fb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/apply_banner_02.png
// module id = o2YG
// module chunks = 34